export class LqdDrawSHapeHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSectionFlow();

  }

  getDefaultSettings() {
    return {
      selectors: {
        sectionFlowElement: '[data-lqd-section-flow]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $sectionFlowElement: this.$element.find(selectors.sectionFlowElement),
    }
  }

  initSectionFlow() {

    this.elements.$sectionFlowElement.liquidSectionFlow();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleThrowableDestroy();

  }

  handleThrowableDestroy() {

    if ( ! this.elements.$sectionFlowElement.length ) return;

    const sectionFlowData = this.elements.$sectionFlowElement.data('plugin_liquidSectionFlow');

    if ( sectionFlowData ) {
      sectionFlowData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdDrawSHapeHandler, { $element } );
};